<template>
  <div class="componentWrapper flock" @click="listenOut" :class="{ true: isShowing }">
    {{findLogoColour}}

    <div id="flock" class="grid grid__item_span-12">
      
      <!-- LEFT COLUMN -->
      <div id="left" class="grid__item_span-6 m0">

        <!-- INTRODUCTION -->
        <div id="intro" class="grid__item_span-12 m0 p0">
          <h2 class="">{{heading}}</h2>
          <p class="grid__item_span-10 m0 p0">{{intro}}</p>
        </div>

        <!-- FLOCK LIST -->
        <div id="flockList" class="grid grid__item_span-12 m0 p0">
          <h4 class="grid__item_span-12 p0 m0 uppercase">{{flockIntro}}</h4>

          <!-- The list wrapper -->
          <div v-for="(item, key) in filterDepartments" class="departmentWrap grid grid__item_span-10 m0 p0">
            <div class="depart grid__item_span-6 m0 alignRight textLightChar" v-if="item === 'project'">Project Management</div>
            <div class="depart grid__item_span-6 m0 alignRight textLightChar" v-else-if="item === 'marketing'">Comms &amp; Marketing</div>
            <div class="depart grid__item_span-6 m0 alignRight textLightChar" v-else>{{item}}</div>
            <div class="names grid grid__item_span-6 m0">
              <p v-for="member in list" v-if="member.team === item" class="m0 p0">
                <router-link :to="{ name: member.slug.name, params: { slug: member.slug.url, id:member.slug.id }}">
                  <span class="flocker" :photo-attr="member.image" @click="show = !show" v-on:mouseover="hover(member.name)" v-on:mouseout="hoverOff()">
                    <span class="line"><div class="inner"></div></span>
                    {{member.name}}
                  </span>
                </router-link>
              </p>
            </div>
          </div>

        </div>
      </div>

      <!-- RIGHT COLUMN / INSTAGRAM FEED -->
      <div id="instagramFeed" class="grid grid__item_span-6 m0">
        <a href="https://www.instagram.com/blcksheepdesign" target="_blank">
          <p id="instagramFollow"class="tag txtCharcol">Follow us @blcksheepdesign</p>
        </a>

       <!-- <iframe src="//lightwidget.com/widgets/547fad0ec9735889a03e5e9a7689aefb.html" scrolling="no" allowtransparency="true" class="lightwidget-widget" style="width:100%;border:0;overflow:hidden;"></iframe> -->

        <!-- LightWidget WIDGET --><iframe src="https://cdn.lightwidget.com/widgets/547fad0ec9735889a03e5e9a7689aefb.html" scrolling="no" allowtransparency="true" class="lightwidget-widget" style="width:100%;border:0;overflow:hidden;"></iframe>

      </div>
    </div>

    <!-- FLOCK MEMBER PHOTO // this appears on hover -->
    <div id="previewImages" >
      <div id="previewImage" class="grid grid__item_span-6 m0" flock="" style=""></div>
      <div class="item" v-for="member in list" :name-attr="member.name">
        <div :style="'background: url(' + member.image + ') no-repeat 0 0 / cover;'" ></div>
      </div>
    </div>

  </div>
</div>
</template> 

<script>

import VueInstagram from 'vue-instagram'
import Profile from '../components/profile.vue'
import singleFlock from '../assets/js/flockers.js'
import menuTransitions from '../assets/js/menu.js'
import Axios from 'axios'

export default {
  name: 'Flock',
  data () {
    return {
      logoColour: 'black',
      isShowing: false,
      show: false,
      metaTitle: '',
      metaDescription: '',
      heading: '',
      intro: '',
      flockIntro: '',
      list: [],
      departments: [],
      departGroups: []
    }
  },
  metaInfo () {
    return {
      title: 'Meet The Flock',
      meta: [
        { vmid: 'description', name: 'description', content: 'Meet the clever creatives that are making good things for nice people all over the place. Designers, web developers, marketing & communications experts and more.' }
      ]
    }
  },
  methods: {
    getData () {
      Axios.get(this.$root.$data.site + '/wp-json/wp/v2/pages/82').then(response => {
        this.metaTitle = response.data.acf.meta_title
        this.metaDescription = response.data.acf.meta_description
        this.logoColour = response.data.acf.bsd_logo_colour
        this.heading = response.data.acf.headline
        this.intro = response.data.acf.flock_paragraph
        this.flockIntro = response.data.acf.the_flock_headline
      }).catch(function (error) {
        console.log(error)
      })

      Axios.get(this.$root.$data.site + '/wp-json/wp/v2/theflock/?per_page=100&order=asc').then(response => {
        var list = response.data.map(obj => {
          return {
            name: obj.title.rendered,
            team: obj.acf.bsd_department,
            image: obj.acf.profile_shot.url,
            ID: obj.acf.id,
            slug: {
              name: 'Profile',
              url: obj.slug,
              id: obj.id
            }
          }
        })
        list.forEach(el => {
          this.list.push(el)
        })

        var departments = response.data.map(obj => {
          return {
            depart: obj.acf.bsd_department
          }
        })
        departments.forEach(el => {
          this.departments.push(el)
        })
      }).catch(function (error) {
        console.log(error)
      })
    },
    hover: function (name, done) {
      singleFlock.nameHover(name, done)
    },
    hoverOff: function (done) {
      singleFlock.nameRemoveHover(done)
    },
    listenOut () { // this is the function which closes the menu
      menuTransitions.hideHeader()
    },
    closeMenuDown () { // after timeout this closes menu
      // console.log('lock down')
      setTimeout(function () {
        // menuTransitions.hideHeader()
        var appWrapper = document.body
        var wrap = document.getElementById('wrap')
        var header = document.getElementById('header')
        var moveheader = document.getElementById('movingHeader')
        var menuBtn = document.getElementById('menuBtn')
        header.classList.remove('true')
        moveheader.classList.remove('true')
        menuBtn.classList.remove('true')
        appWrapper.removeAttribute('style')
        appWrapper.style.overflowY = 'scroll'
        wrap.classList.remove('true')
        var linodes = document.getElementById('menu').childNodes
        for (var a = 0; a < linodes.length; a++) {
          // console.log(linodes[a])
          if (linodes[a].textContent !== ' ') {
            linodes[a].classList.remove('fadeIn')
          }
        }
      }, 2500)
    },
    isMenuOpen () { // on page load if menu is open it will close
      var pageHeader = document.getElementById('header')
      if (pageHeader.classList.contains('true')) {
        // console.log('yay')
        this.isShowing = true
      } else {
        document.getElementById('header').classList.remove('true')
        document.getElementById('movingHeader').classList.remove('true')
        document.getElementById('menuBtn').classList.remove('true')
        var linodes = document.getElementById('menu').childNodes
        for (var a = 0; a < linodes.length; a++) {
          // console.log(linodes[a])
          if (linodes[a].textContent !== ' ') {
            linodes[a].classList.remove('fadeIn')
          }
        }
      }
    }
  },
  mounted () {
    this.isMenuOpen()
    this.closeMenuDown()

    document.getElementById('bsdIcon').style.opacity = 1
    document.getElementById('bsdText').style.opacity = 0

    setTimeout(function () {
      document.getElementById('flock').classList.add('fadeMeIn')
    }, 1500)
  },
  computed: {
    findLogoColour: function () { // request the logo colour
      this.$bus.$emit('bsdLogo', {bsdColour: this.logoColour})
      // return this.logoColour
    },
    filterDepartments: function () {
      for (var i = 0; i < this.departments.length; i++) {
        if (this.departGroups.indexOf(this.departments[i].depart) === -1) {
          this.departGroups.push(this.departments[i].depart)
        }
      }
      return this.departGroups
    }
  },
  created () {
    this.getData()

    let recaptchaScript = document.createElement('script')
    recaptchaScript.setAttribute('src', 'https://cdn.lightwidget.com/widgets/lightwidget.js')
    document.head.appendChild(recaptchaScript)
  },
  components: {
    VueInstagram,
    Profile
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  #previewImage{
    background-repeat: no-repeat;
    background-position:  50% 0;
    background-size: cover;
  }

  .componentWrapper{
    /* padding-top: 13vh;
    padding-left: 2%;
    background: #EFF0F1; */
  }

</style>



// WEBPACK FOOTER //
// src/components/theflock.vue